var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 7.67193L12.3969 4.27505C12.7636 3.90832 13.3582 3.90832 13.7249 4.27505C14.0917 4.64179 14.0917 5.23638 13.7249 5.60312L10.3281 9L13.7249 12.3969C14.0917 12.7636 14.0917 13.3582 13.7249 13.7249C13.3582 14.0917 12.7636 14.0917 12.3969 13.7249L9 10.3281L5.60312 13.7249C5.23638 14.0917 4.64179 14.0917 4.27505 13.7249C3.90832 13.3582 3.90832 12.7636 4.27505 12.3969L7.67193 9L4.27505 5.60312C3.90832 5.23638 3.90832 4.64179 4.27505 4.27505C4.64179 3.90832 5.23638 3.90832 5.60312 4.27505L9 7.67193Z",
    fill: "#151515",
    className: "hc-icons"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterClose);
export default __webpack_public_path__ + "static/media/filter-close.e2af9ac0f6591a8b5d25dfefaabcad28.svg";
export { ForwardRef as ReactComponent };